<template>
    <div class="breadcrumb">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item
                v-for="(item,index) in breadArr"
                :key="index"
                :to="{ path: item.path }"
            >{{item.name}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                breadArr: []
            };
        },
        methods: {
            getCrumbsDetail() {
                console.log('this.$route.query.name', this.$route);
                let type = 'article';
                if (this.$route.name == 'article-list') {
                    type = 'class';
                }
                this.httpGet(this.$root.getCrumbsDetail, {
                    id: this.$route.query.id,
                    type: type
                })
                    .then(result => {
                        this.breadArr.push({
                            name: result.title
                        });
                        this.getBreadArr(result);
                    })
                    .catch(err => {
                        console.error('getCrumbsDetail-err', err);
                    });
            },
            getBreadArr(res) {
                if (res.children && res.children.title) {
                    this.breadArr.push({
                        name: res.children.title
                    });
                    this.getBreadArr(res.children);
                }
                console.log('getBreadArr--', this.breadArr);
            }
        },
        watch: {
            // '$route.query.id': {
            //     immediate: true,
            //     deep: true,
            //     handler(newValue, oldValue) {
            //         if (this.$route.query.id) {
            //             this.breadArr = [];
            //             this.breadArr.push({
            //                 name: '首页',
            //                 path: 'Welcome'
            //             });
            //             this.getCrumbsDetail();
            //         }
            //     }
            // }
            '$store.state.login.breadArr': {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    this.breadArr = newValue;
                }
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    >>>.el-breadcrumb {
        box-sizing: border-box;
        width: 100%;
        max-width: 280px;
        height: 22px;
        flex-x(flex-start);
        padding: 24px 0;
        ellipsis();
    }

    >>>.el-breadcrumb__separator {
        margin: 0 3px;
    }
    >>>.el-breadcrumb__item:hover{
        cursor pointer !important
    }
    >>>.el-breadcrumb__inner.is-link{
        cursor pointer !important
    }
</style>
